import React, { FC, useState, useEffect } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Box, Tooltip, Stack } from '@mui/material';
import { SCUIButton, SCUINoRecordComponent, SCUILoadingLinear } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import Swal from 'sweetalert2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { SCUIShippingCompanyRequestAddToListModal } from './components';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from 'react-i18next';
import { SCUIBreadCrumb, SCUICustomDataGrid, SCUITextFieldWithSelectBox } from '../../atomic/molecules';
import { CargoQuery } from '../../services/query';
import { CargoCommand } from '../../services/command';
import { SCR } from './shippingCompanyRequest.classes';

export const ShippingCompanyRequest: FC<any> = () => {
    const [listModalOpen, setListModalOpen] = useState(false);
    const handleCloseModal = () => {
        setListModalOpen(false);
    };
    const handleOpenModal = () => {
        setListModalOpen(true);
    };
    const { t } = useTranslation();
    const [cargoNameList, setCargoNameList] = useState<any>();
    const [selectedCargo, setSelectedCargo] = React.useState(0);
    const [orderNo, setOrderNo] = React.useState('');
    const [datas, setDatas] = React.useState<any>();
    const [display, setDisplay] = useState(false);
    const [barDisplay, setBarDisplay] = useState(false);

    const GetCargoList = async () => {
        try {
            let cargoList: any = await CargoQuery.CompanyList();
            setCargoNameList([{ id: 0, name: t('general.select') }, ...(cargoList.data || [])]);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };

    useEffect(() => {
        GetCargoList();
    }, []);

    const columns: ExtendedGridColDef[] = [
        {
            field: 'id',
            headerName: 'Id',
            flex: 1,
            hide: true,
            renderCell: (params: any) => (
                <span className={SCR.cellId} data-id={params.row.id}>
                    {params.row.id}
                </span>
            ),
        },
        {
            field: 'shippingNo',
            headerName: t('general.shippingNo'),
            width: 100,
            flex: 1,
            renderCell: (params: any) => (
                <span className={SCR.cellShippingNo} data-shipping-no={params.row.shippingNo}>
                    {params.row.shippingNo}
                </span>
            ),
        },
        {
            field: 'message',
            headerName: t('general.description'),
            flex: 1,
            minWidth: 1200,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.response.message} placement="bottom" arrow>
                        <span
                            className={`table-cell-trucate ${SCR.cellMessage} ${SCR.cellMessageText}`}
                            data-shipping-no={params.row.shippingNo}
                            data-message={params.row.response.message}
                        >
                            {params.row.response.message}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: 'detay',
            headerName: '',
            flex: 1,
            width: 10,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const status = !!params.row.response.status;
                return (
                    <div
                        className={SCR.cellStatus}
                        data-shipping-no={params.row.shippingNo}
                        data-status={String(status)}
                    >
                        {status ? (
                            <CheckCircleIcon
                                color="success"
                                className={`svg_icons ${SCR.cellStatusIcon} ${SCR.cellStatusIconSuccess}`}
                            />
                        ) : (
                            <CancelIcon
                                color="error"
                                className={`svg_icons ${SCR.cellStatusIcon} ${SCR.cellStatusIconError}`}
                            />
                        )}
                    </div>
                );
            },
        },
    ];

    const searchTransferCargoData = async () => {
        if (selectedCargo === 0 || orderNo.trim().length === 0) {
            Swal.fire({
                icon: 'error',
                title: t('general.emptyFieldControlText'),
                showConfirmButton: false,
                timer: 1500,
            });
        } else {
            setBarDisplay(true);
            let cart: any = [];
            let orderArray = orderNo.trim().split('\n');
            orderArray.forEach((item: any) => {
                let params: any = {};
                params.shipmentNo = item;
                params.shippingCompanyId = selectedCargo;
                CargoCommand.PostCargoTransferData(params)
                    .then((res: any) => {
                        let element: any = {};
                        element.id = item;
                        element.shippingNo = item;
                        element.response = res;
                        cart = [...cart, element];
                        setDatas(cart);
                        setBarDisplay(false);
                    })
                    .catch((error: any) => {
                        console.log('Hata :>> ', error);
                    });
            });

            setDisplay(true);
        }
    };

    return (
        <SCUIContent className={SCR.page}>
            <Box className={SCR.root}>
                <SCUIShippingCompanyRequestAddToListModal
                    open={listModalOpen}
                    onClose={handleCloseModal}
                    orderNo={orderNo}
                    setOrderNo={setOrderNo}
                    listele={searchTransferCargoData}
                />
                <Box className={SCR.loading}>
                    <SCUILoadingLinear display={barDisplay} />
                </Box>
                <Box className={SCR.breadcrumb}>
                    <SCUIBreadCrumb
                        title={t('dashboard.shippingCompanyRequest')}
                        componentLink={'ShippingCompanyRequest'}
                    />
                </Box>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 1, sm: 2, md: 4, xl: 20 }}
                    className={SCR.filters}
                >
                    <Box className={SCR.searchBox}>
                        <SCUITextFieldWithSelectBox
                            className={SCR.inputSearchBoxPaper}
                            selectClassName={SCR.inputCargoCompany}
                            inputClassName={SCR.inputShippingNo}
                            iconButtonClassName={SCR.btnSend}
                            placeholder={t('general.shippingNo')}
                            selectId={'id'}
                            selectText={'name'}
                            selectList={cargoNameList}
                            onChangeSelect={(event: any) => {
                                setSelectedCargo(event.target.value as number);
                            }}
                            selectValue={selectedCargo}
                            onChangeTextField={(event: any) => {
                                setOrderNo(event.target.value);
                            }}
                            onClickButton={() => searchTransferCargoData()}
                            onKeyPressTextField={(e: any) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    searchTransferCargoData();
                                }
                            }}
                            buttonText={t('general.send')}
                        />
                    </Box>
                    <SCUIButton
                        className={SCR.btnBatchSearch}
                        text={t('general.batchSearch')}
                        type="secondary"
                        style={{ marginLeft: '16px', height: '40px' }}
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => handleOpenModal()}
                    />
                </Stack>

                {display && datas ? (
                    <Box className={SCR.grid}>
                        <SCUICustomDataGrid rows={datas} columns={columns} allrecord hideFooter />
                    </Box>
                ) : (
                    <Box className={SCR.emptyState}>
                        <SCUINoRecordComponent />
                    </Box>
                )}
            </Box>
        </SCUIContent>
    );
};
